import { useContext } from 'react'
import { FeatureFlagContext } from 'Core/FeatureFlagContext'
import { LICENSE_MODES } from './constants'

export { LICENSE_MODES, LICENSE_VIEWS, licenseRouteSegment } from './constants'

/**
 * Live license mode — the licensed view currently active (Current, Agent
 * Privilege, PAM Privilege). State is owned by FeatureFlagContext alongside
 * viewMode and persisted to the user's server-side preferences, so it
 * survives reloads and devices; switching from the profile dropdown and
 * reading here stay in lockstep through the same context value.
 *
 * Return contract is stable for consumers (the Overview dashboard's section
 * gates and the Sidemenu filter); when real tenant licensing lands, only the
 * boot-time default in FeatureFlagContext needs to change.
 */
export const useLicense = () => {
  const context = useContext(FeatureFlagContext)
  const licenseMode = context?.data?.licenseMode || LICENSE_MODES.COMBINED

  return {
    licenseMode,
    setLicenseMode: context?.updateLicenseMode || (() => {}),
    isCombined: licenseMode === LICENSE_MODES.COMBINED,
    isAgentOnly: licenseMode === LICENSE_MODES.AGENT_ONLY,
    isHumanOnly: licenseMode === LICENSE_MODES.HUMAN_ONLY
  }
}
